/*
 * @Date: 2020-03-13 23:38:10
 * @LastEditTime: 2020-03-15 13:57:18
 * @Description: file content
 */
import Vue from 'vue'
import {
  Upload,
  Message,
  Row,
  Col,
  Input,
  Progress,
  MessageBox,
  Checkbox,
  CheckboxGroup,
  Table,
  TableColumn
} from 'element-ui'
Vue.use(Upload)
Vue.use(Row)
Vue.use(Col)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Progress)
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
